import { connect } from 'react-redux';
import {
  fetchInventoryItems,
  deleteInventoryItem
} from '../../../redux/Inventory/sagas/item/routines';
import {
  clearInventoryItems,
  inventoryItemsOnChangePage,
  inventoryItemsOnChangeOrder
} from '../../../redux/Inventory/actions';
import {
  getIsFetching as getIsFetchingItems,
  getIsFetched as getIsFetchedItems,
  getIsDeleting as getIsDeletingItem,
  getIsDeleted as getIsDeletedItem,
  getDeletingError as getDeleteItemError,
  getOrder as getItemsOrder
} from '../../../redux/Inventory/selectors/item';
import {
  getPaginationLoadedPages,
  getPaginationWithoutPages,
  getPaginationQueryOptions,
  getCurrentPageItems
} from '../../../redux/Inventory/selectors/item/pagination';
import { getSearchQueryForContext } from '../../../redux/Inventory/selectors/components/search';
import paginationAndSearchQuery from '../../../helpers/paginationAndSearchQuery';
import { ItemType } from '../../../constants/inventory/InventoryTypes';
import SEARCH_CONTEXT from '../../../helpers/InventorySearchContext';
import InventoryItemList from '../../../components/inventory/ItemList';
import orderList from '../../../helpers/orderList';

function mapStateToProps(state) {
  const paginationQuery = getPaginationQueryOptions(state);
  const searchQuery = getSearchQueryForContext(state, SEARCH_CONTEXT.ITEM);
  const order = getItemsOrder(state);
  return {
    type: ItemType,
    items: orderList(order, getCurrentPageItems(state)),
    query: { ...paginationAndSearchQuery(paginationQuery, searchQuery), order },
    loadedPages: getPaginationLoadedPages(state),
    pagination: getPaginationWithoutPages(state),
    isFetching: getIsFetchingItems(state),
    isFetched: getIsFetchedItems(state),
    isDeleting: getIsDeletingItem(state),
    isDeleted: getIsDeletedItem(state),
    deleteError: getDeleteItemError(state)
  };
}

function mapDispatchToProps(dispatch) {
  return {
    onInit: query => {
      dispatch(fetchInventoryItems(query));
    },
    onDelete: item => {
      dispatch(deleteInventoryItem(item));
    },
    onChangePage: (query, isPageLoaded) => {
      const { page } = query;
      if (!isPageLoaded) dispatch(fetchInventoryItems(query));
      else dispatch(inventoryItemsOnChangePage(page));
    },
    onChangeLimit: query => {
      dispatch(clearInventoryItems());
      dispatch(fetchInventoryItems(query));
    },
    onSort: (sortBy, sortOrder, query) => {
      const order = `${sortBy}:${sortOrder}`;
      dispatch(clearInventoryItems());
      dispatch(fetchInventoryItems({ ...query, order }));
      dispatch(inventoryItemsOnChangeOrder(order));
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InventoryItemList);
